<template>
  <el-select
    v-model="input"
    :remote-method="querySearch"
    placeholder="Enter name of Carrier"
    multiple
    filterable
    remote
    class="w-100"
    placement="top"
    clearable
    :loading="isLoading"
  >
    <el-option
      v-for="(item, index) in data"
      :key="index"
      :label="item.long"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {

  data () {
    return {
      input: '',
      data: [],
      isLoading: false
    }
  },

  methods: {
    querySearch (queryString) {
      this.isLoading = true
      this.$sdk.dictionary_bgroup.list(builder => {
        builder.filters = { bgroup_long: queryString }
      }).then(res => {
        this.data = res
        this.isLoading = false
      })
    },
    getBGID () {
      return this.input
    }
  }
}
</script>

<style>

</style>
